// extracted by mini-css-extract-plugin
module.exports = {"button1":"button_button1__2lfAj","button2":"button_button2__11gVY","body":"button_body__NuhCu"};